import * as blueprint from '@adc/blueprint'
import React, { useMemo } from 'react'
import { Progress, Text } from '@adc/ui-core'
import _cx from 'classnames/bind'
import cls from '../styles.scss'
const cx = _cx.bind(cls)

const useREOPurchaseProfiles = ({ user, graphWebsocket }) => {
  const purchaseProfiles =
    blueprint.purchaseProfiles.hooks.useReoPurchaseProfiles({
      enabled: global.__CLIENT_BUNDLE__,
      initialData: { user },
      graphWebsocket,
    })
  const defaultPurchaseProfile = useMemo(
    () =>
      purchaseProfiles.find(option => option.percent_complete === 100)
        ?.offer_template_id || null,
    [purchaseProfiles]
  )
  const dropdownOptions = useMemo(() => {
    return purchaseProfiles.map(p => ({
      disabled: p.percent_complete !== 100,
      text: (
        <div
          className={cx('dropdown-option', {
            'not-allowed': p.percent_complete !== 100,
          })}
        >
          <Text className={cx('u-mr-1')}>{p.template_name}</Text>
          <Progress
            className={cx('progress-bar')}
            percent={p.percent_complete}
            color='green'
            warning={p.percent_complete < 100}
            progress
            data-elm-id={`reo_profile_${p.offer_template_id}_progress_bar`}
          />
        </div>
      ),
      value: p.offer_template_id,
    }))
  }, [purchaseProfiles])

  return {
    purchaseProfiles,
    defaultPurchaseProfile,
    dropdownOptions,
    createLink: '/dashboard/purchase-profiles/create',
    isRequired: true, // TODO: get this to actually affect the form, may need to be controlled by outside like occupancy disclaimer
  }
}

const useForeclosurePurchaseProfiles = ({ user, graphWebsocket }) => {
  const purchaseProfiles =
    blueprint.purchaseProfiles.hooks.useForeclosurePurchaseProfiles({
      enabled: global.__CLIENT_BUNDLE__,
      initialData: { user },
      graphWebsocket,
    })
  const dropdownOptions = useMemo(() => {
    return purchaseProfiles.map(p => ({
      text: p.profile_name,
      value: p.purchase_profile_id,
    }))
  }, [purchaseProfiles])

  const defaultPurchaseProfile = useMemo(
    () =>
      purchaseProfiles.find(p => p.is_default)?.purchase_profile_id ||
      purchaseProfiles[0]?.purchase_profile_id,
    [purchaseProfiles]
  )

  return {
    purchaseProfiles,
    defaultPurchaseProfile,
    dropdownOptions,
    createLink: '/dashboard/purchase-profiles/fcl/create',
    isRequired: true, // TODO: get this to actually affect the form, may need to be controlled by outside like occupancy disclaimer
  }
}

export const usePurchaseProfiles = ({ user, isREO, graphWebsocket }) => {
  return isREO
    ? useREOPurchaseProfiles({ user, graphWebsocket })
    : useForeclosurePurchaseProfiles({ user, graphWebsocket })
}
